module.exports = __webpack_public_path__ + "img/payment_confirm.db1c3095.png";